import React, { useEffect, useState, useRef } from 'react';
import '../css/RiskAssessment.css';
import '../App.css';
import CHOPHeader from './CHOPHeader';
import PicuHeader from './PicuHeader';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { withStyles } from '@mui/styles';
import { Radio, Checkbox, TextareaAutosize } from "@mui/material";
import { useLocation, useNavigate} from "react-router-dom";
import getObservationEncounterData from '../services/getObservationEncounterData';
import getObservationPatientData from "../services/getObservationPatientData";
import getRiskFactor from "../services/getRiskFactor";
import saveData from '../services/saveData';
import WriteToLog from '../services/WriteToLog';
import { Select, MenuItem, FormControl, InputLabel, TextField } from '@mui/material';
import AO_Default from '../img/AO_Default.png';
import redalert from '../img/exclamation.png';
import { isMobileOnly } from 'react-device-detect';
import calculateHeartRate from '../services/calculateHeartRate';
import calculateSystolicBPRate from '../services/calculateSystolicBPRate';
import calculateOverWeight from '../services/calculateOverWeight';
import getAAOModelPrediction from '../services/getAAOModelPrediction';
import roundToTwoDecimalsIfNeeded from '../services/roundToTwoDecimalsIfNeeded';
import axios from "axios";

const checkBoxStyles = theme => ({
  root: {
    '&$checked': {
      color: '#005587',
    },
  },
  checked: {},
 })

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);

const RiskAssessment = () => {
  const title = "Risk Assessment";
  const note = "";
  const navigate = useNavigate();

  const [helperErrorText, setHelperErrorText] = React.useState('');
  const [helperHistoryText, setHelperHistoryText] = React.useState('');
  const [DIFFICULT_AIRWAY_HISTORY, setSelectedValue] = React.useState('');
  const handleChangeHistory = (event) => {
    setSelectedValue(event.target.value);
    setHelperHistoryText('');
  };

  const [helperPhysicalText, setHelperPhysicalText] = React.useState('');
  const [PHYSICAL_SIGNS, setSelectedValue1] = React.useState('');
  const handleChangePhysical = (event) => {
    setSelectedValue1(event.target.value);
    setHelperPhysicalText('');
  };

  const [helperRiskText, setHelperRiskText] = React.useState('');
  const [HIGH_RISK_DESATURATION, setSelectedValue2] = React.useState('');
  const handleChangeHighRisk = (event) => {
    setSelectedValue2(event.target.value);
    setHelperRiskText('');
  };

  const [helperIncreasedText, setHelperIncreasedText] = React.useState('');
  const [INCREASED_ICP, setSelectedValue3] = React.useState('');
  const handleChangeIncreased= (event) => {
    setSelectedValue3(event.target.value);
    setHelperIncreasedText('');
  };

  const [helperUnstableText, setHelperUnstableText] = React.useState('');
  const [UNSTABLE_HEMODYNAMICS, setSelectedValue4] = React.useState('');
  const handleChangeUnstable = (event) => {
    setSelectedValue4(event.target.value);
    setHelperUnstableText('');
  };

  const [OTHER_RISK_FACTORS, setSelectedValue5] = React.useState('');
  const handleChangeOther = (event) => {
    setSelectedValue5(event.target.value);
  };

  const [physicalsigns,setPhysicalSigns] = useState([]);

  const handleChecked = (event) => {
    var physicalsigns_array = [...physicalsigns];
    if (event.target.checked) {
      physicalsigns_array = [...physicalsigns, event.target.value];
    } else {
      physicalsigns_array.splice(physicalsigns.indexOf(event.target.value), 1);
    }
    setPhysicalSigns(physicalsigns_array.filter(Boolean));
  };

  const [OTHER_RISK_FACTORS_NOTES, setOtherRisk] = useState('');

  const [decisions,setDecisions] = useState([]);

  const handleCheckedDecisions = (event) => {
    var decisions_array = [...decisions];
    if (event.target.checked) {
      decisions_array = [...decisions, event.target.value];
    } else {
      decisions_array.splice(decisions.indexOf(event.target.value), 1);
    }
    setDecisions(decisions_array.filter(Boolean));
  };

  const [progressIndicator, setProgressIndicator] = React.useState(true);

  const location = useLocation();
  const { selectedPatient } = location.state;
  
  const banner = selectedPatient.need_patient_banner;
  const room = selectedPatient.ROOM + ' ' + selectedPatient.BED;
  const name = selectedPatient.DISPLAY_NAME;
  const mrn = selectedPatient.MRN;
  const dob = selectedPatient.DOB;
  const gender = selectedPatient.gender;
  const age = selectedPatient.DISPLAY_AGE;
  var age_number = selectedPatient.AGE; //returned in years
  //console.log("age_number: " + age_number);
  var age_exact_months = selectedPatient.AGE_IN_EXACT_MONTHS;
  //console.log("age_exact_months: " + age_exact_months);
  var age_in_days = selectedPatient.AGE_IN_DAYS;
  //console.log("age_in_days: " + age_in_days);
  const [shockHeartRateRisk, setShockHeartRateRisk] = React.useState('none');
  const [shockSystolicBPRisk, setShockSystolicBPRisk] = React.useState('none');
  const [medsAdministeredRisk, setMedsAdministeredRisk] = React.useState('none');
  const [baseExcessRisk, setBaseExcessRisk] = React.useState('none');
  const [lactateBloodRisk, setLactateBloodRisk] = React.useState('none');
  const [difficultAirwayRisk, setDifficultAirwayRisk] = React.useState('none');
  const [cspineInjuryRisk, setCSpineInjuryRisk] = React.useState('none');
  const [cspineInstabilityRisk, setCSpineInstabilityRisk] = React.useState('none');
  const [overweightRisk, setOverweightRisk] = React.useState('none');
  const [BiPAPRisk, setBiPAPRisk] = React.useState('none');
  const [FiO2Risk, setFiO2Risk] = React.useState('none');
  
  const [INTUBATION_PRIOR_PROCEDURE, setIntubationValue] = React.useState('');
  const handleIntubation = (event) => {
    if (event.target.checked) {
      setIntubationValue(event.target.value);
    } else {
      setIntubationValue('');    
    }
  };

  const [NIV_SUPPORT_LIMITS, setNIVValue] = React.useState('');
  const handleNIV = (event) => {
    if (event.target.checked) {
      setNIVValue(event.target.value);
    } else {
      setNIVValue('');    
    }
  };

  const [FIO2, setFIO2] = React.useState('');
  const [EPAP, setEPAP] = React.useState('');
  const [IPAP, setIPAP] = React.useState('');

  const [OTHER, setOtherValue] = React.useState('');
  const handleOther = (event) => {
    if (event.target.checked) {
      setOtherValue(event.target.value);
    } else {
      setOtherValue('');    
    }
  };

  const [OTHER_NOTES, setOtherNotes] = useState('');

  /* Default Primary ETT Size based on Patient's age */
  var defaultETTSize = '';
  if (age_number <= 1) {
    defaultETTSize = '3.5';
  }
  if (age_number > 1 && age_number <= 2) {
    defaultETTSize = '4';
  }
  if (age_number > 2 && age_number <= 16) {
    defaultETTSize = Math.round(age_number/4 + 4 - 0.5);
  }
  if (age_number > 16) {
    defaultETTSize = '7';
  }
  const [PRIMARY_ETT_SIZE, setSize] = React.useState(defaultETTSize);
  const handleChangeSize = (event) => {
    setSize(event.target.value);
    setApproved(false);
  };

  /* Cuffed by default for Primary ETT Type */
  const [PRIMARY_ETT_TYPE, setType] = React.useState('Cuffed');
  const handleChangeType = (event) => {
    setType(event.target.value);
    setApproved(false);
  };

  const [primaryBladeTypes, setPrimaryBladeTypes] = useState([]);
  /* Default Primary Device, Blade Type, Blade Size based on Patient's age */
  var defaultDevice = "";
  var defaultBladeType = "";
  var defaultBladeSize = "";
  if (age_number < 1) {
    defaultDevice = "CMAC";
    defaultBladeType = "Miller";
    defaultBladeSize = "1";
  }
  if (age_number >= 1 && age_number <= 3) {
    defaultDevice = "Laryngoscope";
    defaultBladeType = "WisHipple";
    defaultBladeSize = "1.5"; 
  }
  if (age_number > 3 && age_number <= 12) {
    defaultDevice = "CMAC";
    defaultBladeType = "Mac";
    defaultBladeSize = "2";
  }
  if (age_number > 12) {
    defaultDevice = "CMAC";
    defaultBladeType = "Mac";
    defaultBladeSize = "3";
  }
  
  const [PRIMARY_DEVICE, setDevice] = useState('');
  const [PRIMARY_BLADE_TYPE, setBladeType] = useState('');
  const [primaryBladeSizes, setPrimaryBladeSizes] = useState([]);
  const [PRIMARY_BLADE_SIZE, setBladeSize] = React.useState('');

  const primaryDevices = {
    CMAC: ["Mac", "Miller"],
    Laryngoscope: ["Mac", "Miller", "WisHipple"],
    Glidescope: ["Miller", "Macintosh", "Hyperangulated"],
    Other: []
  };

  const primaryBladeTypesSizes = {
    Mac: ["2", "3", "4"],
    Miller: ["00", "0", "1", "2"],
    WisHipple: ["1.5"],
    Macintosh: ["3", "4"],
    Hyperangulated: ["1", "2", "2.5", "3", "4"]
  };

  const primaryDeviceList = Object.keys(primaryDevices).map(key => ({
    name: key
  }));

  const handleChangeDevice = (event) => {
    //console.log("Selected Device", event.target.value);
    const deviceSel = event.target.value;
    const bladeTypeSel = deviceSel !== "" ? primaryDevices[deviceSel] : [];
    setDevice(deviceSel);
    setPrimaryBladeTypes(bladeTypeSel);
    /*if (deviceSel === "Glidescope") {
      setBladeType("None");
      setPrimaryBladeSizes(primaryBladeTypesSizes["None"]);
    } else {*/
      setBladeType("");
    //}
    setApproved(false);
  }

  const handleChangeBladeType = (event) => {
    //console.log("Selected Blade Type", event.target.value);
    const bladeTypeSel = event.target.value;
    const bladeSizeSel = bladeTypeSel !== "" ? primaryBladeTypesSizes[bladeTypeSel] : [];
    setBladeType(bladeTypeSel);
    setPrimaryBladeSizes(bladeSizeSel);
    if (bladeTypeSel === "WisHipple") {
      setBladeSize("1.5");
    } else {
      setBladeSize("");
    }
    setApproved(false);
  }

  const handleChangeBladeSize = (event) => {
    setBladeSize(event.target.value);
    setApproved(false);
  };

  const [OTHER_PRIMARY_DEVICE, setOtherPrimaryDevice] = React.useState('');

  const [BACKUP_PLANNED, setBackupPlanned] = React.useState('');
  const handleBackupPlanned = (event) => {
    if (event.target.checked) {
      setBackupPlanned(event.target.value);
    } else {
      setBackupPlanned('');    
    }
  };

  const [BACKUP_ETT_SIZE, setBackupSize] = React.useState('');
  const handleChangeBackupSize = (event) => {
    setBackupSize(event.target.value);
  };

  const [BACKUP_ETT_TYPE, setBackupType] = React.useState('');
  const handleChangeBackupType = (event) => {
    setBackupType(event.target.value);
  };

  const [BACKUP_DEVICE, setBackupDevice] = React.useState('');
  const [BACKUP_BLADE_TYPE, setBackupBladeType] = React.useState('');
  const [backupBladeSizes, setBackupBladeSizes] = useState([]);
  const [BACKUP_BLADE_SIZE, setBackupBladeSize] = React.useState('');
  const [backupBladeTypes, setBackupBladeTypes] = useState([]);

  const backupDevices = {
    CMAC: ["Mac", "Miller"],
    Laryngoscope: ["Mac", "Miller", "WisHipple"],
    Glidescope: ["Miller", "Macintosh", "Hyperangulated"],
    Other: []
  };

  const backupBladeTypesSizes = {
    Mac: ["2", "3", "4"],
    Miller: ["00", "0", "1", "2"],
    WisHipple: ["1.5"],
    Macintosh: ["3", "4"],
    Hyperangulated: ["1", "2", "2.5", "3", "4"]
  };

  const backupDeviceList = Object.keys(backupDevices).map(key => ({
    name: key
  }));

  const handleChangeBackupDevice = (event) => {
    const backupDeviceSel = event.target.value;
    const backupBladeTypeSel = backupDeviceSel !== "" ? backupDevices[backupDeviceSel] : [];
    setBackupDevice(backupDeviceSel);
    setBackupBladeTypes(backupBladeTypeSel);
    /*if (backupDeviceSel === "Glidescope") {
      setBackupBladeType("None");
      setBackupBladeSizes(primaryBladeTypesSizes["None"]);
    } else {*/
      setBackupBladeType("");
    //}
  };

  const handleChangeBackupBladeType = (event) => {
    const backupBladeTypeSel = event.target.value;
    const backupBladeSizeSel = backupBladeTypeSel !== "" ? backupBladeTypesSizes[backupBladeTypeSel] : [];
    setBackupBladeType(backupBladeTypeSel);
    setBackupBladeSizes(backupBladeSizeSel);
    if (backupBladeTypeSel === "WisHipple") {
      setBackupBladeSize("1.5");
    } else {
      setBackupBladeSize("");
    }
  };

  const handleChangeBackupBladeSize = (event) => {
    setBackupBladeSize(event.target.value);
  };

  const [OTHER_BACKUP_DEVICE, setOtherBackupDevice] = React.useState('');

  /* By Default check Apneic Oxygenation */
  const [APNEIC_OXYGENATION, setApneic] = React.useState('Y');
  const handleApneic = (event) => {
    if (event.target.checked) {
      setApneic(event.target.value);
    } else {
      setApneic('');    
    }
  };

  /* Auto populate by age */
  var defaultRate = '';
  if (age_number < 1) {
    defaultRate = '5';
  }
  if (age_number >= 1 && age_number <= 7) {
    defaultRate = '10';
  }
  if (age_number >= 8) {
    defaultRate = '15';
  }
  const [RATE, setRate] = React.useState(defaultRate);

  const [medications,setMedications] = useState([]);

  const handleMedication = (event) => {
    var med_array = [...medications];
    if (event.target.checked) {
      med_array = [...medications, event.target.value];
    } else {
      med_array.splice(medications.indexOf(event.target.value), 1);
    }
    setMedications(med_array.filter(Boolean)); // Clear '' values
  };

  const [MEDICATION_OTHER_NOTES, setMedicationNotes] = useState('');

  /* Set No by default */
  const [ANESTHESIA, setAnesthesiaValue] = React.useState('N');
  const handleAnesthesiaValue = (event) => {
    setAnesthesiaValue(event.target.value);
  };

  /* Set No by default */
  const [ENT, setENTValue] = React.useState('N');
  const handleENTValue = (event) => {
    setENTValue(event.target.value);
  };

  const [approved, setApproved] = React.useState(false);
  const [primaryError, setPrimaryError] = React.useState('');

  const [predictionRisk, setPredictionRisk] = React.useState('');
  const [riskFactors, setRiskFactors] = React.useState();

  /* Get Latest Risk Assessment data if any in EHR */
  useEffect(() => {
    async function fetchData() {
      if (defaultDevice === "CMAC" || defaultDevice === "Laryngoscope") {
        const bladeTypeSel = defaultDevice !== "" ? primaryDevices[defaultDevice] : [];
        setDevice(defaultDevice);
        setPrimaryBladeTypes(bladeTypeSel);
        setBladeType(defaultBladeType);
        const bladeSizeSel = defaultBladeType !== "" ? primaryBladeTypesSizes[defaultBladeType] : [];
        //setBladeType(bladeTypeSel);
        setPrimaryBladeSizes(bladeSizeSel);
        setBladeSize(defaultBladeSize);
      }

      if (selectedPatient.patFHIRID) {
        /* Get Risk Factors for Non-admitted Patients */
        if (selectedPatient.CSN !== '99999') { 
          const ehrconfig = await axios.get('ehrconfig.json');
          let riskGroup = ehrconfig.data["RISK_GROUP_VALUE"];
          const EHR_RESPIRATORY_DEVICE_VALUE = ehrconfig.data["EHR_RESPIRATORY_DEVICE_VALUE"];

          /* Clinical Decision Support - Get Risk Factor */
          const riskResponse = await getRiskFactor(selectedPatient.patFHIRID, selectedPatient.CSN, selectedPatient.MRN, selectedPatient.fhir_server, selectedPatient.access_token);
          if (riskResponse) {
            setProgressIndicator(true);
            WriteToLog("getRiskFactor response: " + JSON.stringify(riskResponse)); 

            if (riskResponse.labs) {
              const lactateblood = [];
              const baseexcess = [];
              const EHR_BLOOD_GAS_LACTATE_LOINC_CODES = riskResponse.EHR_BLOOD_GAS_LACTATE_LOINC_CODES;
              const bloodGasLactateArr = EHR_BLOOD_GAS_LACTATE_LOINC_CODES.split(",");
              const EHR_BLOOD_GAS_BASE_EXCESS_LOINC_CODES = riskResponse.EHR_BLOOD_GAS_BASE_EXCESS_LOINC_CODES;
              const baseExcessArr = EHR_BLOOD_GAS_BASE_EXCESS_LOINC_CODES.split(",");
              const labs = riskResponse.labs;
              Object.keys(labs).forEach(key => {
                //console.log(key + ": " + JSON.stringify(labs[key].value));
                if (bloodGasLactateArr.includes(key)) {
                  lactateblood.push(labs[key].value);
                }
                if (baseExcessArr.includes(key)) {
                  baseexcess.push(labs[key].value);
                }
              });

              //console.log("lactateblood: " + lactateblood);
              //console.log("baseexcess: " + baseexcess);
              const lactateBloodGreaterThan3 = lactateblood.some(number => number > 3);
              if (lactateBloodGreaterThan3) {
                WriteToLog("lactateBloodGreaterThan3: " + lactateBloodGreaterThan3);
                setLactateBloodRisk("yes");
              }
      
              const baseExcessLessThanMinus8 = baseexcess.some(be => be < -8);
              if (baseExcessLessThanMinus8) {
                WriteToLog("baseExcessLessThanMinus8: " + baseExcessLessThanMinus8);
                setBaseExcessRisk("yes");
              }
            }

            if (riskResponse.HeartRate) {
              calculateHeartRate(riskResponse.HeartRate.value, age_exact_months).then(function(hrrisk) {
                setShockHeartRateRisk(hrrisk); 
              });
            }
            if (riskResponse.BP) {
              calculateSystolicBPRate(riskResponse.BP.value, age_in_days).then(function(bprisk) {
                setShockSystolicBPRisk(bprisk);
              });
            }
            if (riskResponse.MedsAdministered) {
              if (riskResponse.MedsAdministered.length > 0) {
                setMedsAdministeredRisk("yes");
              }
            }
            if (riskResponse.DifficultAirway) {
              setDifficultAirwayRisk("yes");
            }
            if (riskResponse.CSpineInjury) {
              setCSpineInjuryRisk("yes");
            }
            if (riskResponse.CSpineInstability) {
              setCSpineInstabilityRisk("yes");
            }
            if (riskResponse.Weight) {
              calculateOverWeight(riskResponse.Weight.value, gender, age_exact_months).then(function(weightrisk) {
                setOverweightRisk(weightrisk);
              });
            }

            var BiPAP_number = 0;
            if(riskResponse.BiPAP) {
              BiPAP_number = riskResponse.BiPAP.value;
            }
            var BiPAPSet_number = 0;
            if (riskResponse.BiPAPSet) {
              BiPAPSet_number = riskResponse.BiPAPSet.value;
            }
            if (riskResponse.RespDevice) {
              if (riskResponse.RespDevice.includes(EHR_RESPIRATORY_DEVICE_VALUE)) {
                if (BiPAP_number > 16 || BiPAPSet_number > 16) {
                  setBiPAPRisk("yes");
                }
              }
            }
            if (riskResponse.FiO2) {
              var CPAP_number = 0;
              var CPAPSet_number = 0;
              if (riskResponse.CPAP) {
                CPAP_number = riskResponse.CPAP.value;
              }
              if (riskResponse.CPAPSet) {
                CPAPSet_number = riskResponse.CPAPSet.value;
              }
              var FiO2_number = riskResponse.FiO2.value;
              if (riskResponse.RespDevice) {
                if (riskResponse.RespDevice.includes(EHR_RESPIRATORY_DEVICE_VALUE)) {
                  if (FiO2_number > 50 && (CPAP_number > 0 || CPAPSet_number > 0 || BiPAP_number > 0 || BiPAPSet_number > 0)) {
                    setFiO2Risk("yes");
                  }
                }
              }
            }
            setProgressIndicator(false);

            var date = new Date();
            const currentdatetime = date.toISOString().slice(0, 19) + 'Z';

            /* Build JSON data */
            let patientJSON = {};
            patientJSON.message_creation_time = currentdatetime;
            patientJSON.patient_id = selectedPatient.PATIENT_ID;
            let demographics = {};
            demographics.DOB = dob;
            demographics.gender = gender;
            patientJSON.demographics = demographics;
            let adt = {};
            adt.icu_admission_time = selectedPatient.AdmitDate;
            patientJSON.adt = adt;
            let problem_list = {};
            problem_list.difficult_airway = {};
            if (riskResponse.Conditions) {
              if (riskResponse.Conditions.length > 0) {
                problem_list.difficult_airway.diagnoses = riskResponse.Conditions;
              } 
            } else {
              problem_list.difficult_airway.diagnoses = [];
            }
            patientJSON.problem_list = problem_list;
            
            let flowsheet = {};
            flowsheet.resp = {};

            if (riskResponse.BiPAPSet) {
              flowsheet.resp.peak_inspiratory_pressure_set = riskResponse.BiPAPSet; // Flowsheet ID 40010946
            } else {
              flowsheet.resp.peak_inspiratory_pressure_set = {};
              flowsheet.resp.peak_inspiratory_pressure_set.value = null;
              flowsheet.resp.peak_inspiratory_pressure_set.timestamp = null;
            }
            if (riskResponse.BiPAP){
              flowsheet.resp.peak_inspiratory_pressure_actual = riskResponse.BiPAP; // Flowsheet ID 40000699
            } else {
              flowsheet.resp.peak_inspiratory_pressure_actual = {};
              flowsheet.resp.peak_inspiratory_pressure_actual.value = null;
              flowsheet.resp.peak_inspiratory_pressure_actual.timestamp = null;
            }
            if (riskResponse.CPAPSet) {
              flowsheet.resp.peep_set = riskResponse.CPAPSet; // Flowsheet ID 40000566
            } else {
              flowsheet.resp.peep_set = {};
              flowsheet.resp.peep_set.value = null;
              flowsheet.resp.peep_set.timestamp = null;
            }
            if (riskResponse.CPAP) {
              flowsheet.resp.peep_actual = riskResponse.CPAP; // Flowsheet ID 4000010947
            } else {
              flowsheet.resp.peep_actual = {};
              flowsheet.resp.peep_actual.value = null;
              flowsheet.resp.peep_actual.timestamp = null;
            }
            if (riskResponse.FiO2) {
              flowsheet.resp.fio2 = riskResponse.FiO2; // Flowsheet ID 40002468
            } else {
              flowsheet.resp.fio2 = {};
              flowsheet.resp.fio2.value = null;
              flowsheet.resp.fio2.timestamp = null;
            }

            if (riskResponse.FlowRate) {
              flowsheet.resp.hfnc = riskResponse.FlowRate;
            } else {
              flowsheet.resp.hfnc = {};
              flowsheet.resp.hfnc.value = null;
              flowsheet.resp.hfnc.timestamp = null;
            }

            flowsheet.vital_signs = {};
            if (riskResponse.SpO2) {
              flowsheet.vital_signs.spo2 = riskResponse.SpO2;
            } else {
              flowsheet.vital_signs.spo2 = null;
            }
            if (riskResponse.HeartRate) {
              flowsheet.vital_signs.heart_rate = riskResponse.HeartRate;
            } else {
              flowsheet.vital_signs.heart_rate = null;
            }
            if (riskResponse.art) {
              flowsheet.vital_signs.map_art = riskResponse.art; // Flowsheet ID 400700102
            } else {
              flowsheet.vital_signs.map_art = null;
            }
            if (riskResponse.cuff) {
              flowsheet.vital_signs.map_cuff = riskResponse.cuff; // Flowsheet ID 40000675
            } else {
              flowsheet.vital_signs.map_cuff = null;
            }
            if (riskResponse.BP) {
              flowsheet.vital_signs.systolic_bp = riskResponse.BP;
            } else {
              flowsheet.vital_signs.systolic_bp = null;
            }
            if (riskResponse.Diastolic) {
              flowsheet.vital_signs.diastolic_bp = riskResponse.Diastolic;
            } else {
              flowsheet.vital_signs.diastolic_bp = null;
            }
            if (riskResponse.Temp) {
              flowsheet.vital_signs.temperature = riskResponse.Temp; 
            } else {
              flowsheet.vital_signs.temperature = null; 
            }
            
            flowsheet.obesity = {};
            if (riskResponse.Weight) {
              flowsheet.obesity.timestamp = riskResponse.Weight.timestamp;
              flowsheet.obesity.weight_kg = riskResponse.Weight;
              delete flowsheet.obesity.weight_kg["timestamp"];
            } else {
              flowsheet.obesity.timestamp = null;
              flowsheet.obesity.weight_kg = null;
            }
            patientJSON.flowsheet = flowsheet;

            let mar = {};
            if (riskResponse.Orders) {
              mar.Orders = riskResponse.Orders;
            } else {
              mar.Orders = [];
            }
            patientJSON.mar = mar;     
            patientJSON.lab = riskResponse.labs;

            WriteToLog("Patient JSON: " + JSON.stringify(patientJSON));
            getAAOModelPrediction(patientJSON, selectedPatient.fhir_server).then(predictionValue => {
              //WriteToLog("AAO Model Prediction Value: " + JSON.stringify(predictionValue));
              /* Save AAO Prediction Model data to EHR */
              if (predictionValue) {
                let modelValue = JSON.stringify({request: patientJSON, output: predictionValue});
                saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.riskModel, modelValue, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token).then(modelResponse => {
                  if (modelResponse === "success") {
                    WriteToLog('AAO Model Prediction data saved successfully for patient: ' + selectedPatient.PATIENT_ID);
                  }
                });
              }

              // Note: Low < 0.11, medium 0.11-<0.22, high >0.22
              if (predictionValue && predictionValue.output && predictionValue.output.length > 0) {
                let riskNumber = Number(predictionValue.output[0].risk);
                if (riskNumber >= 0.11 && riskNumber <= 0.22) {
                  setPredictionRisk('medium');
                }
                if (riskNumber > 0.22) {
                  setPredictionRisk('high');
                }
                if (predictionValue.output[0].top_risk_factors.length > 0) {
                  let topRiskFactors = predictionValue.output[0].top_risk_factors;
                  let riskDisplayValues = [];

                  for (var i= 0; i < topRiskFactors.length; i++) {
                    if (topRiskFactors[i].direction === "positive") {
                      let var_name = topRiskFactors[i].var_name;
                      let var_value = topRiskFactors[i].var_value;
                      let displayName = "";
                      for (const [key, valueArray] of Object.entries(riskGroup)) {
                        if (Array.isArray(valueArray) && valueArray.includes(var_name)) {      
                          if (typeof var_value === "number") {
                            if (var_name.includes("Age")) {
                              displayName = key + " : " + selectedPatient.DISPLAY_AGE;
                            } else {
                              displayName = key + " : " + roundToTwoDecimalsIfNeeded(var_value);
                            }
                            if (!riskDisplayValues.some(k => k.includes(key + " : ")) && riskDisplayValues.length < 3) {
                              riskDisplayValues.push(displayName);
                            }
                          } else {
                            displayName = key;
                            if (!riskDisplayValues.some(k => k.includes(key)) && riskDisplayValues.length < 3) {
                              riskDisplayValues.push(displayName);
                            }
                          }
                        }
                      }           
                    }
                  }
                  WriteToLog("Risk: " + riskNumber + "AAO Model Prediction value: " + riskDisplayValues);
                  setRiskFactors(riskDisplayValues);
                }
              } else {
                // Display Model Prediction Not Available message
                setPredictionRisk('unavailable');
              }
            });
          }
        } else { // end of if selectedPatient.CSN admitted
          setProgressIndicator(false);
        }

        if (selectedPatient.PLAN_COMPLETE_TIMESTAMP && selectedPatient.PLAN_COMPLETE_TIMESTAMP !== "") {
          if (selectedPatient.CSN && selectedPatient.CSN !== '99999') { // admitted
            // Plan Exists - Get Plan data from CHOPABC#003 (planId)
            getObservationEncounterData(selectedPatient.patFHIRID, selectedPatient.encFHIRID, selectedPatient.planId, selectedPatient.fhir_server, selectedPatient.access_token)
            .then(response => { 
              WriteToLog("getObservationEncounterData PlanId response: " + JSON.stringify(response)); 
              if (response && response !== "") {
                var json = JSON.parse(response);
                setSelectedValue(json.DIFFICULT_AIRWAY_HISTORY); 
                setSelectedValue1(json.PHYSICAL_SIGNS);
                setPhysicalSigns(json.PHYSICAL_SIGNS_VALUE.split(','));
                setSelectedValue2(json.HIGH_RISK_DESATURATION);
                setSelectedValue3(json.INCREASED_ICP);
                setSelectedValue4(json.UNSTABLE_HEMODYNAMICS);
                setSelectedValue5(json.OTHER_RISK_FACTORS);
                setOtherRisk(json.OTHER_RISK_FACTORS_NOTES);
                if (json.DECISION_SUPPORT) {
                  setDecisions(json.DECISION_SUPPORT.split(','));
                } 
                setIntubationValue(json.INTUBATION_PRIOR_PROCEDURE); 
                setNIVValue(json.NIV_SUPPORT_LIMITS);
                setFIO2(json.FIO2);
                setEPAP(json.EPAP);
                setIPAP(json.IPAP);
                setOtherValue(json.OTHER);
                setOtherNotes(json.OTHER_NOTES);
                setSize(json.PRIMARY_ETT_SIZE);
                setType(json.PRIMARY_ETT_TYPE);
                setDevice(json.PRIMARY_DEVICE);
                /* Populate Primary Blade Type dropdown values before selection */
                setPrimaryBladeTypes(primaryDevices[json.PRIMARY_DEVICE]);
                setBladeType(json.PRIMARY_BLADE_TYPE);
                /* Populate Primary Blade Size dropdown values before selection */    
                setPrimaryBladeSizes(primaryBladeTypesSizes[json.PRIMARY_BLADE_TYPE]);
                setBladeSize(json.PRIMARY_BLADE_SIZE);
                setOtherPrimaryDevice(json.OTHER_PRIMARY_DEVICE);
                setBackupPlanned(json.BACKUP_PLANNED);
                setBackupSize(json.BACKUP_ETT_SIZE);
                setBackupType(json.BACKUP_ETT_TYPE);
                setBackupDevice(json.BACKUP_DEVICE);
                /* Populate Backup Blade Type dropdown values before selection */
                setBackupBladeTypes(backupDevices[json.BACKUP_DEVICE]);
                setBackupBladeType(json.BACKUP_BLADE_TYPE);     
                /* Populate Backup Blade Size dropdown values before selection */   
                setBackupBladeSizes(backupBladeTypesSizes[json.BACKUP_BLADE_TYPE]);
                setBackupBladeSize(json.BACKUP_BLADE_SIZE);
                setOtherBackupDevice(json.OTHER_BACKUP_DEVICE);
                setApneic(json.APNEIC_OXYGENATION);
                setRate(json.RATE);
                if(json.MEDICATION) {
                  setMedications(json.MEDICATION.split(','));
                }
                setMedicationNotes(json.MEDICATION_OTHER_NOTES);
                setAnesthesiaValue(json.ANESTHESIA);
                setENTValue(json.ENT);
              }
            })
            .catch(e => {
              WriteToLog('RiskAssessment.getObservationEncounterData error: ', e);
              navigate('/error', { state: { selectedPatient : selectedPatient, failure: "getting the Plan data from EHR" } });
            });
          } else { // non-admitted
            // Get Plan Data from tempPlanId
            getObservationPatientData(selectedPatient.patFHIRID, selectedPatient.tempPlanId, selectedPatient.fhir_server, selectedPatient.access_token)
            .then(response => { 
              //WriteToLog("getObservationPatientData tempPlan response: " + JSON.stringify(response)); 
              if (response && response !== "") {
                var json = JSON.parse(response);

                setSelectedValue(json.DIFFICULT_AIRWAY_HISTORY); 
                setSelectedValue1(json.PHYSICAL_SIGNS);
                setPhysicalSigns(json.PHYSICAL_SIGNS_VALUE.split(','));
                setSelectedValue2(json.HIGH_RISK_DESATURATION);
                setSelectedValue3(json.INCREASED_ICP);
                setSelectedValue4(json.UNSTABLE_HEMODYNAMICS);
                setSelectedValue5(json.OTHER_RISK_FACTORS);
                setOtherRisk(json.OTHER_RISK_FACTORS_NOTES);
                if (json.DECISION_SUPPORT) {
                  setDecisions(json.DECISION_SUPPORT.split(','));
                } 
                setIntubationValue(json.INTUBATION_PRIOR_PROCEDURE); 
                setNIVValue(json.NIV_SUPPORT_LIMITS);
                setFIO2(json.FIO2);
                setEPAP(json.EPAP);
                setIPAP(json.IPAP);
                setOtherValue(json.OTHER);
                setOtherNotes(json.OTHER_NOTES);
                setSize(json.PRIMARY_ETT_SIZE);
                setType(json.PRIMARY_ETT_TYPE);
                setDevice(json.PRIMARY_DEVICE);
                /* Populate Primary Blade Type dropdown values before selection */
                setPrimaryBladeTypes(primaryDevices[json.PRIMARY_DEVICE]);
                setBladeType(json.PRIMARY_BLADE_TYPE);
                /* Populate Primary Blade Size dropdown values before selection */    
                setPrimaryBladeSizes(primaryBladeTypesSizes[json.PRIMARY_BLADE_TYPE]);
                setBladeSize(json.PRIMARY_BLADE_SIZE);
                setOtherPrimaryDevice(json.OTHER_PRIMARY_DEVICE);
                setBackupPlanned(json.BACKUP_PLANNED);
                setBackupSize(json.BACKUP_ETT_SIZE);
                setBackupType(json.BACKUP_ETT_TYPE);
                setBackupDevice(json.BACKUP_DEVICE);
                /* Populate Backup Blade Type dropdown values before selection */
                setBackupBladeTypes(backupDevices[json.BACKUP_DEVICE]);
                setBackupBladeType(json.BACKUP_BLADE_TYPE);     
                /* Populate Backup Blade Size dropdown values before selection */   
                setBackupBladeSizes(backupBladeTypesSizes[json.BACKUP_BLADE_TYPE]);
                setBackupBladeSize(json.BACKUP_BLADE_SIZE);
                setOtherBackupDevice(json.OTHER_BACKUP_DEVICE);
                setApneic(json.APNEIC_OXYGENATION);
                setRate(json.RATE);
                if(json.MEDICATION) {
                  setMedications(json.MEDICATION.split(','));
                }
                setMedicationNotes(json.MEDICATION_OTHER_NOTES);
                setAnesthesiaValue(json.ANESTHESIA);
                setENTValue(json.ENT);
              } else { // If tempPlan Empty, do nothing
                WriteToLog("tempPlan is empty?");
              }
            })
            .catch(e => {
              WriteToLog('RiskAssessment.getObservationEncounterData tempPlan error: ', e);
              navigate('/error', { state: { selectedPatient : selectedPatient, failure: "getting the Plan data for non-admitted patients from EHR" } });
            });
          }
        } // end of if PLAN_COMPLETE_TIMESTAMP
      } // end of if patFHIRID
    }
    fetchData();
  }, [age_exact_months, age_in_days, defaultBladeSize, defaultBladeType, defaultDevice, dob, gender, navigate, selectedPatient]);

  const planForm = useRef();

  /* Save Risk Assessment form to EHR */
  const handleSubmit = async(e) => {
    e.preventDefault();
    e.stopPropagation();

    // Close without saving button
    if (planForm.current.buttonId === 'close') {
      navigate('/selected', { state: { selectedPatient:selectedPatient } });
    }

    const data = {DIFFICULT_AIRWAY_HISTORY, PHYSICAL_SIGNS, HIGH_RISK_DESATURATION, INCREASED_ICP, UNSTABLE_HEMODYNAMICS, OTHER_RISK_FACTORS, OTHER_RISK_FACTORS_NOTES, INTUBATION_PRIOR_PROCEDURE, NIV_SUPPORT_LIMITS, FIO2, EPAP, IPAP, OTHER, OTHER_NOTES, PRIMARY_ETT_SIZE, PRIMARY_ETT_TYPE, PRIMARY_DEVICE, PRIMARY_BLADE_TYPE, PRIMARY_BLADE_SIZE, OTHER_PRIMARY_DEVICE, BACKUP_PLANNED, BACKUP_ETT_SIZE, BACKUP_ETT_TYPE, BACKUP_DEVICE, BACKUP_BLADE_TYPE, BACKUP_BLADE_SIZE, OTHER_BACKUP_DEVICE, APNEIC_OXYGENATION, RATE, MEDICATION_OTHER_NOTES, ANESTHESIA, ENT};
    if (data.PHYSICAL_SIGNS === 'Y') {
      data.PHYSICAL_SIGNS_VALUE = physicalsigns.toString();
    } else {
      data.PHYSICAL_SIGNS_VALUE = '';
    }
    data.DECISION_SUPPORT = decisions.toString();
    data.MEDICATION = medications.toString();
    var today = new Date();
    var currentdate = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear();
    var currentdatetime = today.getFullYear() + '-' + ("0"+(today.getMonth()+1)).slice(-2) + '-' + ("0"+today.getDate()).slice(-2) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    data.CREATE_DATETIME = currentdatetime;

    const isValid = formValidation();
    if (isValid) {
      setHelperErrorText('');
      if (approved) {
        if (selectedPatient.CSN && selectedPatient.CSN !== '99999') { // admitted
          WriteToLog("ADMITTED: Contains CSN value. Save to planId");

          /* Step 1: Save Plan data to EHR */
          let ehrValue = JSON.stringify(data);
          let ehrResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.planId, ehrValue, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
          if (ehrResponse === "success") {
            WriteToLog('Plan saved successfully for patient: ' + selectedPatient.PATIENT_ID);       
            // Step 2: Save Plan Complete Date to EHR
            let planDateResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.planDateId, currentdate, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
            if (planDateResponse === "success") {
              WriteToLog('PlanDate saved successfully for patient: ' + selectedPatient.PATIENT_ID); 
              // Step 3: Update selectedPatient object
              selectedPatient.PLAN_COMPLETE_TIMESTAMP = currentdate;
              selectedPatient.PLAN_STATUS = "Plan Complete";  
              
              // Step 4: Route user to Page based on button selection
              if (planForm.current.buttonId === 'saveclose') {
                navigate('/selected', { state: { selectedPatient:selectedPatient } });
              }        
              if (planForm.current.buttonId === 'save') {
                navigate('/timeout', { state: { selectedPatient:selectedPatient } });
              }
            } else {
              WriteToLog("Plan Complete Date not saved to EHR: " + planDateResponse);
              navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Plan Complete Date into EHR" } });
            }
          } else {
            WriteToLog("Plan not saved to EHR: " + ehrResponse);
            navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Plan into EHR" } });
          }
        } else { // non-admitted
          WriteToLog("NON-ADMITTED: CSN is NULL/EMPTY/99999. Save to tempPlanId");

          /* Step 1: Save Plan data to EHR tempPlan */
          let ehrValue = JSON.stringify(data);
          let ehrResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.tempPlanId, ehrValue, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
          //WriteToLog("After saveData tempPlan response: " + ehrResponse); 
          if (ehrResponse === "success") {
            //WriteToLog('TempPlan saved successfully for patient: ' + selectedPatient.PATIENT_ID);       
            // Step 2: Save Plan Complete Date to EHR Patient
            let planDateResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.planDateId, currentdate, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
            if (planDateResponse === "success") {
              WriteToLog('PlanDate saved successfully for patient: ' + selectedPatient.PATIENT_ID); 
              // Update selectedPatient object
              selectedPatient.PLAN_COMPLETE_TIMESTAMP = currentdate;
              selectedPatient.PLAN_STATUS = "Plan Complete";            
              // Step 3: Route user to Page based on button selection
              if (planForm.current.buttonId === 'saveclose') {
                navigate('/selected', { state: { selectedPatient:selectedPatient } });
              }        
              if (planForm.current.buttonId === 'save') {
                navigate('/timeout', { state: { selectedPatient:selectedPatient } });
              }
            } else {
              WriteToLog("Plan Complete Date not saved to EHR: " + planDateResponse);
              navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Plan Complete Date into EHR for non-admitted patients" } });
            }
          } else {
            WriteToLog("Plan not saved to EHR: " + ehrResponse);
            navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Plan into EHR for non-admitted patients" } });
          }
        }
      } else {
        setPrimaryError('Device parameters must be approved');
        setHelperErrorText('Device parameters must be approved');
      }
    } else {
      setHelperErrorText("Please select or enter the required fields");
    }
  };

  const formValidation = () => {
    let isValid = true;

    if(DIFFICULT_AIRWAY_HISTORY === "Y" || DIFFICULT_AIRWAY_HISTORY === "N") {
      setHelperHistoryText('');
    } else {
      setHelperHistoryText("This field is required");
      isValid = false;
    }

    if(PHYSICAL_SIGNS === "Y" || PHYSICAL_SIGNS === "N") {
      setHelperPhysicalText('');
    } else {
      setHelperPhysicalText("This field is required");
      isValid = false;
    }

    if(HIGH_RISK_DESATURATION === "Y" || HIGH_RISK_DESATURATION === "N") {
      setHelperRiskText('');
    } else {
      setHelperRiskText("This field is required");
      isValid = false;
    }

    if(INCREASED_ICP === "Y" || INCREASED_ICP === "N") {
      setHelperIncreasedText('');
    } else {
      setHelperIncreasedText("This field is required");
      isValid = false;
    }

    if(UNSTABLE_HEMODYNAMICS === "Y" || UNSTABLE_HEMODYNAMICS === "N") {
      setHelperUnstableText('');
    } else {
      setHelperUnstableText("This field is required");
      isValid = false;
    }

    if (isValid) {
      setHelperErrorText('');
    }

    return isValid;
  }

  const approvePrimary = () => {
    if (PRIMARY_DEVICE === 'Other') {
      if (PRIMARY_ETT_SIZE && PRIMARY_ETT_TYPE && PRIMARY_DEVICE && OTHER_PRIMARY_DEVICE) {
        setApproved(true);
        setPrimaryError('');
      } else {
        setPrimaryError('Device parameters must be selected');
      }
    } else {
      if (PRIMARY_ETT_SIZE && PRIMARY_ETT_TYPE && PRIMARY_DEVICE && PRIMARY_BLADE_TYPE && PRIMARY_BLADE_SIZE) {
        setApproved(true);
        setPrimaryError('');
      } else {
        setPrimaryError('Device parameters must be selected');
      }
    }
  };

  return (
    <div className='RiskAssessment'>
      <CHOPHeader />
      <PicuHeader banner={banner} room={room} name={name} mrn={mrn} dob={dob} age={age} gender={gender} title={title} note={note} />

      <form onSubmit={handleSubmit} noValidate ref={planForm}>
        <Container fluid="md" className="assessment">
          <Row className="align-center">
            <Col xs={8} sm={8} md={10} lg={8}><span className="sub-header">Difficult Airways</span></Col>
            <Col xs={4} sm={4} md={2} lg={4}> &nbsp;&nbsp;Yes &nbsp;&nbsp;&nbsp; No</Col>
          </Row>
          <Row className="blue-row">
            <Col xs={8} sm={8} md={10} lg={8}>History of difficult airway?</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
              <Radio
                  name="history" 
                  checked={DIFFICULT_AIRWAY_HISTORY === 'Y'}
                  onChange={handleChangeHistory}
                  value="Y"
                />
                <Radio
                  name="history" 
                  checked={DIFFICULT_AIRWAY_HISTORY === 'N'}
                  onChange={handleChangeHistory}
                  value="N"
                />
            </Col>
          </Row>
          <Row className="align-center custom-error">{helperHistoryText}</Row>
          <Row className="align-center">
            <Col xs={8} sm={8} md={10} lg={8}>Physical signs?</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  name="physical"
                  checked={PHYSICAL_SIGNS === 'Y'}
                  onChange={handleChangePhysical}
                  value="Y"
                />
                <Radio
                  name="physical"
                  checked={PHYSICAL_SIGNS === 'N'}
                  onChange={handleChangePhysical}
                  value="N"
                />
            </Col>
          </Row>
          <Row className="align-center custom-error">{helperPhysicalText}</Row>
          {PHYSICAL_SIGNS === 'Y' && (
            <span>
              <Row className="add-bottom-border">
                <Col xs={8} sm={8} md={10} lg={8}><span className="left-space">Small mouth</span></Col>
                <Col xs={4} sm={4} md={2} lg={4}><CustomCheckbox value="Small mouth" checked={physicalsigns.indexOf("Small mouth") > -1} onClick={handleChecked} inputProps={{ 'aria-label': 'controlled' }} /></Col>
              </Row>
              <Row className="add-bottom-border">
                <Col xs={8} sm={8} md={10} lg={8}><span className="left-space">Small jaw</span></Col>
                <Col xs={4} sm={4} md={2} lg={4}><CustomCheckbox value="Small jaw" checked={physicalsigns.indexOf("Small jaw") > -1} onClick={handleChecked} inputProps={{ 'aria-label': 'controlled' }} /></Col>
              </Row>
              <Row className="add-bottom-border">
                <Col xs={8} sm={8} md={10} lg={8}><span className="left-space">Large tongue</span></Col>
                <Col xs={4} sm={4} md={2} lg={4}><CustomCheckbox value="Large tongue" checked={physicalsigns.indexOf("Large tongue") > -1} onClick={handleChecked} inputProps={{ 'aria-label': 'controlled' }} /></Col>
              </Row>
              <Row className="add-bottom-border">
                <Col xs={8} sm={8} md={10} lg={8}><span className="left-space">Short neck</span></Col>
                <Col xs={4} sm={4} md={2} lg={4}><CustomCheckbox value="Short neck" checked={physicalsigns.indexOf("Short neck") > -1} onClick={handleChecked} inputProps={{ 'aria-label': 'controlled' }} /></Col>
              </Row>
              <Row className="align-center">
                <Col xs={8} sm={8} md={10} lg={8}><span className="left-space">C-collar</span></Col>
                <Col xs={4} sm={4} md={2} lg={4}><CustomCheckbox value="C-collar" checked={physicalsigns.indexOf("C-collar") > -1} onClick={handleChecked} inputProps={{ 'aria-label': 'controlled' }} /></Col>
              </Row>
            </span>
          )}

          <hr/> 
          <Row>
            <Col xs={8} sm={8} md={10} lg={8}><span className="sub-header">Risk Factors</span></Col>
            <Col xs={4} sm={4} md={2} lg={4}></Col>
          </Row>
          <Row className="blue-row">
            <Col xs={8} sm={8} md={10} lg={8}>High risk for rapid desaturation during intubation</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  name="highrisk"
                  checked={HIGH_RISK_DESATURATION === 'Y'}
                  onChange={handleChangeHighRisk}
                  value="Y"
                />
                <Radio
                  name="highrisk"
                  checked={HIGH_RISK_DESATURATION === 'N'}
                  onChange={handleChangeHighRisk}
                  value="N"
                />
            </Col>
          </Row>
          <Row className="align-center custom-error">{helperRiskText}</Row>
          <Row className="bottom-space align-center">
            <Col xs={8} sm={8} md={10} lg={8}>Increased ICP, pulmonary hypertension, need to avoid hypercarbia</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  name="increased"
                  checked={INCREASED_ICP === 'Y'}
                  onChange={handleChangeIncreased}
                  value="Y"
                />
                <Radio
                  name="increased"
                  checked={INCREASED_ICP === 'N'}
                  onChange={handleChangeIncreased}
                  value="N"
                />
            </Col>
          </Row>
          <Row className="align-center custom-error">{helperIncreasedText}</Row>
          <Row className="blue-row">
            <Col xs={8} sm={8} md={10} lg={8}>Unstable hemodynamics (eg. hypovolemia, potential need for fluid bolus, vasorpressor, CPR)</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  name="unstable"
                  checked={UNSTABLE_HEMODYNAMICS === 'Y'}
                  onChange={handleChangeUnstable}
                  value="Y"
                />
                <Radio
                  name="unstable"
                  checked={UNSTABLE_HEMODYNAMICS === 'N'}
                  onChange={handleChangeUnstable}
                  value="N"
                />
            </Col>
          </Row>
          <Row className="align-center custom-error">{helperUnstableText}</Row>
          <Row className="align-center bottom-space">
            <Col xs={8} sm={8} md={10} lg={8}>Other risk factors</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  checked={OTHER_RISK_FACTORS === 'Y'}
                  onChange={handleChangeOther}
                  value="Y"
                  name="other"
                  inputProps={{ 'aria-label': 'Y' }}
                />
                <Radio
                  checked={OTHER_RISK_FACTORS === 'N'}
                  onChange={handleChangeOther}
                  value="N"
                  name="other"
                  inputProps={{ 'aria-label': 'N' }}
                />
            </Col>
          </Row>
          {OTHER_RISK_FACTORS  === 'Y' && (
              <Row className="adjust-row-width left-space">
                <TextareaAutosize aria-label="comments" minRows={2} value={OTHER_RISK_FACTORS_NOTES} onChange={e => setOtherRisk(e.target.value)} placeholder="Please describe" />
              </Row>  
          )}
        </Container>

        <PicuHeader title="Decision Support" note="" />
        {progressIndicator && <p className='progress-indicator'>Please wait, processing...</p>}
        {(predictionRisk === "medium") && (
          <div class="assessment-div">
          <h3>Risk Prediction</h3>
            <div class="risk-div">
              <div class="risk-table">
                <div class="medium-risk">
                  <h4>MEDIUM RISK</h4>
                  <p>Risk of Adverse Airway Outcome (TIAE or severe desaturation)</p>
                </div>
                <div class="risks">
                  <div>
                    <h4>TOP 3 RISK FACTORS</h4>
                    <ul>
                      {riskFactors.map((item, i) => (
                      <li>{item}</li>
                      ))}
                    </ul>
                  </div>  
                </div>
              </div>
            </div>
          </div>
        )}
        {(predictionRisk === "high") && (
          <div class="assessment-div">
          <h3>Risk Prediction</h3>
            <div class="risk-div">
              <div class="risk-table">
                <div class="high-risk">
                  <h4>HIGH RISK</h4>
                  <p>Risk of Adverse Airway Outcome (TIAE or severe desaturation)</p>
                </div>
                <div class="risks">
                  <div>
                    <h4>TOP 3 RISK FACTORS</h4>
                    <ul>
                      {riskFactors.map((item, i) => (
                      <li>{item}</li>
                      ))}
                    </ul>
                  </div>  
                </div>
              </div>
            </div>
          </div>
        )}
        {(predictionRisk === "unavailable") && (
          <div class="assessment-div">
          <h4>Risk Prediction not available at this point</h4>
          </div>
        )}
        <Container fluid="md" className="assessment">
          <Row>
            <Col xs={4} sm={4} md={4} lg={4}><span className="sub-header table-header">Risk Factor</span></Col>
            <Col xs={6} sm={6} md={6} lg={4}><span className="sub-header table-header">Suggestion</span></Col>
            <Col xs={2} sm={2} md={2} lg={4}><span className="sub-header table-header">Include in Plan</span></Col>
          </Row>
          <Row className="blue-row">
            {(shockHeartRateRisk === "yes" || shockSystolicBPRisk === "yes" || medsAdministeredRisk === "yes" || lactateBloodRisk === "yes" || baseExcessRisk === "yes") && (
            <Col xs={4} sm={4} md={4} lg={4}><font color="red">Shock/hemodynamic instability </font><img className="red-alert" src={redalert} alt="Risk"></img></Col>
            )}
            {(shockHeartRateRisk === "none" && shockSystolicBPRisk === "none" && medsAdministeredRisk === "none" && lactateBloodRisk === "none" && baseExcessRisk === "none") && (
            <Col xs={4} sm={4} md={4} lg={4}>Shock/hemodynamic instability</Col>
            )}
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Prepare Fluid Bolus</li><li>Prepare Epinephrine bolus or infusion</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="Shock" checked={decisions.indexOf("Shock") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4}>Cardiac Arrest</Col>
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Is patient an ECMO candidate?</li><li>Is ECMO backup needed?</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="Cardiac" checked={decisions.indexOf("Cardiac") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row className="blue-row">
            {(BiPAPRisk === "yes" || FiO2Risk === "yes") && (
              <Col xs={4} sm={4} md={4} lg={4}><font color="red">Respiratory Failure with high NIV/HFNC support </font><img className="red-alert" src={redalert} alt="Risk"></img></Col>
            )}
            {(BiPAPRisk === "none" && FiO2Risk === "none") && (
              <Col xs={4} sm={4} md={4} lg={4}>Respiratory Failure with high NIV/HFNC support</Col>
            )}
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Make LMA available at bedside</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>            
              <CustomCheckbox value="Respiratory" checked={decisions.indexOf("Respiratory") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row>
          {(cspineInjuryRisk === "yes" || cspineInstabilityRisk === "yes") && (
            <Col xs={4} sm={4} md={4} lg={4}><font color="red">C-spine precaution </font><img className="red-alert" src={redalert} alt="Risk"></img></Col>
          )}
          {(cspineInjuryRisk === "none" && cspineInstabilityRisk === "none") && (
            <Col xs={4} sm={4} md={4} lg={4}>C-spine precaution</Col>
          )}
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Prepare video laryngoscope</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="C-spine" checked={decisions.indexOf("C-spine") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>       
          <Row className="blue-row">
          {difficultAirwayRisk === "yes" && (
            <Col xs={4} sm={4} md={4} lg={4}><font color="red">History or feature of difficult airway </font><img className="red-alert" src={redalert} alt="Risk"></img></Col>
          )}
          {difficultAirwayRisk === "none" && (
            <Col xs={4} sm={4} md={4} lg={4}>History or feature of difficult airway</Col>
          )}
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Review previously successful airway management</li><li>Prepare LMA and backup tool</li><li>Match provider skill with complexity</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="History" checked={decisions.indexOf("History") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row>
          {overweightRisk === "yes" && (
            <Col xs={4} sm={4} md={4} lg={4}><font color="red">Obese patient </font><img className="red-alert" src={redalert} alt="Risk"></img></Col>
          )}
          {overweightRisk === "none" && (
            <Col xs={4} sm={4} md={4} lg={4}>Obese patient</Col>
          )}
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Prepare ramp up system, oral airway</li><li>Start with two-person bag mask technique</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="Obese" checked={decisions.indexOf("Obese") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row className="blue-row">
            <Col xs={4} sm={4} md={4} lg={4}>Pulmonary edema/airway bleeding</Col>
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Be ready to switch to direct laryngoscopy</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="Pulmonary" checked={decisions.indexOf("Pulmonary") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4}>Pulmonary Overcirculation [CICU only]</Col>
            <Col xs={6} sm={6} md={6} lg={4}><ul><li>Place bag on  oxygen blender</li></ul></Col>
            <Col xs={2} sm={2} md={2} lg={4}>
              <CustomCheckbox value="Overcirculation" checked={decisions.indexOf("Overcirculation") > -1} onClick={handleCheckedDecisions} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
        </Container>

        <PicuHeader title="Intubation Plan" note="" />
        <Container fluid="md" className="assessment">
          <p><span className="sub-header">Reasons to Intubate</span></p>
          <span><hr/></span>
          <Row className="align-center">
            <Col xs={8} sm={8} md={4} lg={4}>Intubation prior to procedure</Col>
            <Col xs={4} sm={4} md={2} lg={2}>
              <CustomCheckbox checked={INTUBATION_PRIOR_PROCEDURE === 'Y'} value="Y" onChange={handleIntubation} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          <Row className="align-center">
            <Col xs={8} sm={8} md={4} lg={4}>NIV support limits</Col>
            <Col xs={4} sm={4} md={2} lg={2}>
            <CustomCheckbox checked={NIV_SUPPORT_LIMITS === 'Y'} value="Y" onChange={handleNIV} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
            <Col>
            {NIV_SUPPORT_LIMITS  === 'Y' && (
              <span><TextField inputProps={{ style: { height: "10px", }, }} className="small-text-field" margin="normal" variant="outlined" size="small" label="FiO2" value={FIO2} onChange={e => setFIO2(e.target.value)}></TextField><span className="wordContainer small-note">
              <span className="top">%</span>
              <span className="down"></span>
              </span><TextField inputProps={{ style: { height: "10px", }, }} className="small-text-field" margin="normal" variant="outlined" size="small" label="IPAP" value={IPAP} onChange={e => setIPAP(e.target.value)}></TextField><span className="wordContainer small-note">
              <span className="top">cm</span>
              <span className="down">H2O</span>
              </span><TextField inputProps={{ style: { height: "10px", }, }} className="small-text-field" margin="normal" variant="outlined" size="small" label="EPAP" value={EPAP} onChange={e => setEPAP(e.target.value)}></TextField><span className="wordContainer small-note">
              <span className="top">cm</span>
              <span className="down">H2O</span>
              </span></span> 
            )}
            </Col>
          </Row>
          <Row className="align-center">
            <Col xs={8} sm={8} md={4} lg={4}>Other</Col>
            <Col xs={4} sm={4} md={2} lg={2}>
            <CustomCheckbox checked={OTHER === 'Y'} value="Y" onClick={handleOther} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
            <Col>
              {OTHER  === 'Y' && (
              <Row className="adjust-row-width left-space">
                <TextField inputProps={{ style: { height: "10px", }, }} margin="normal" variant="outlined" size="small" value={OTHER_NOTES} onChange={e => setOtherNotes(e.target.value)} />
              </Row>  
              )}
            </Col>
          </Row>
          <span className="sub-header">Equipment Selection</span>
          <span><hr/></span>
          <p>Primary Equipment</p>
          <Row>
            <Col xs={3} sm={2} md={2} lg={2}>
              <FormControl>
              <InputLabel id="ett-size-label">ETT Size</InputLabel>
              <Select 
                labelId="ett-size-label" 
                value={PRIMARY_ETT_SIZE} 
                onChange={handleChangeSize}
                required
                style={{
                width: 100,
                }} >
                <MenuItem value={2.5}>2.5</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={3.5}>3.5</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={4.5}>4.5</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={5.5}>5.5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={6.5}>6.5</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={7.5}>7.5</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={8.5}>8.5</MenuItem>
                <MenuItem value={0}>Other</MenuItem>
              </Select>
              </FormControl>
            </Col>
            <Col sm={2}>
              <FormControl>
              <InputLabel id="ett-type-label">ETT Type</InputLabel>
              <Select labelId="ett-type-label" value={PRIMARY_ETT_TYPE} required onChange={handleChangeType} style={{
                width: 100,
                }}>
                <MenuItem value={"Cuffed"}>Cuffed</MenuItem>
                <MenuItem value={"Uncuffed"}>Uncuffed</MenuItem>
              </Select>
              </FormControl>
            </Col>
            <Col sm={3}>
              <FormControl>
              <InputLabel id="device-label">Device</InputLabel>
              <Select labelId="device-label" value={PRIMARY_DEVICE} defaultValue={defaultDevice} required onChange={handleChangeDevice} style={{
                width: 140,
                }} >
                  <MenuItem value={""}>Select</MenuItem>
                  {primaryDeviceList && primaryDeviceList.map((device, key) => (
                  <MenuItem value={device.name}>{device.name}</MenuItem>
                ))}
              </Select>
              </FormControl>
            </Col>
            {PRIMARY_DEVICE  !== 'Other' && (
            <Col sm={2}>
              <FormControl>
              <InputLabel id="blade-type-label">Blade Type</InputLabel>
              <Select labelId="blade-type-label" value={PRIMARY_BLADE_TYPE} required onChange={handleChangeBladeType} style={{
                width: 110,
                }}>
                <MenuItem value={""}>Select</MenuItem>
                {primaryBladeTypes && primaryBladeTypes.map((bladetype, key) => (
                  <MenuItem value={bladetype}>{bladetype}</MenuItem>
                ))}
              </Select>
              </FormControl>
            </Col> )}
            {PRIMARY_DEVICE  !== 'Other' && (
            <Col sm={2}>
              <FormControl>
              <InputLabel id="blade-size-label">Blade Size</InputLabel>
              <Select labelId="blade-size-label" value={PRIMARY_BLADE_SIZE} required onChange={handleChangeBladeSize} style={{
                width: 100,
                }}>
                <MenuItem value={""}>Select</MenuItem>
                {primaryBladeSizes && primaryBladeSizes.map((bladesize, key) => (
                  <MenuItem value={bladesize}>{bladesize}</MenuItem>
                ))}
              </Select>
              </FormControl>
            </Col> )}
            {PRIMARY_DEVICE  === 'Other' && (
              <Col sm={4}>
                <TextField inputProps={{ style: { height: "10px", }, }} margin="normal" variant="outlined" fullWidth value={OTHER_PRIMARY_DEVICE} onChange={e => setOtherPrimaryDevice(e.target.value)} required></TextField>
              </Col>
            )}
          </Row>
          <p className="small-note-italics">Primary equipment includes BOTH primary ETT and 1/2 size smaller prior</p>
          {!approved ? (<button type="button" className="close-btn" onClick={approvePrimary}>Approve Primary</button>) : (<button type="button" className="approved-btn" disabled>Approved</button>)}
          &nbsp;<span className="custom-error-font">{primaryError}</span>
          <Row className="align-center">
            <Col xs={5} sm={4} md={4} lg={4}>Backup Equipment</Col>
            <Col xs={2} sm={2} md={2} lg={2}>
              <CustomCheckbox checked={BACKUP_PLANNED === 'Y'} value="Y" onClick={handleBackupPlanned} inputProps={{ 'aria-label': 'controlled' }} />
            </Col>
          </Row>
          {BACKUP_PLANNED  === 'Y' && (
            <Row>
              <Col sm={2}>
                <FormControl>
                <InputLabel id="ett-size-label">Airway Size</InputLabel>
                <Select 
                  labelId="ett-size-label" 
                  value={BACKUP_ETT_SIZE} 
                  onChange={handleChangeBackupSize}
                  style={{
                  width: 100,
                  }} >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={0.5}>0.5</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={1.5}>1.5</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={2.5}>2.5</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={3.5}>3.5</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={4.5}>4.5</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={5.5}>5.5</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                  <MenuItem value={6.5}>6.5</MenuItem>
                  <MenuItem value={7}>7</MenuItem>
                  <MenuItem value={7.5}>7.5</MenuItem>
                  <MenuItem value={8}>8</MenuItem>
                  <MenuItem value={8.5}>8.5</MenuItem>
                  <MenuItem value={0}>Other</MenuItem>
                </Select>
                </FormControl>
              </Col>
              <Col sm={2}>
                <FormControl>
                <InputLabel id="ett-type-label">Airway Type</InputLabel>
                <Select labelId="ett-type-label" value={BACKUP_ETT_TYPE} onChange={handleChangeBackupType} style={{
                  width: 100,
                  }}>
                  <MenuItem value={"Cuffed"}>Cuffed</MenuItem>
                  <MenuItem value={"Uncuffed"}>Uncuffed</MenuItem>
                  <MenuItem value={"LMA"}>LMA</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </Select>
                </FormControl>
              </Col>
              <Col sm={3}>
                <FormControl>
                <InputLabel id="device-label">Device</InputLabel>
                <Select labelId="device-label" value={BACKUP_DEVICE} required onChange={handleChangeBackupDevice} style={{
                  width: 140,
                  }}>
                  <MenuItem value={""}>Select</MenuItem>
                  {backupDeviceList && backupDeviceList.map((backupdevice, key) => (
                  <MenuItem value={backupdevice.name}>{backupdevice.name}</MenuItem>
                  ))}
                </Select>
                </FormControl>
              </Col>
              {BACKUP_DEVICE  !== 'Other' && (
              <Col sm={2}>
                <FormControl>
                <InputLabel id="blade-type-label">Blade Type</InputLabel>
                <Select labelId="blade-type-label" value={BACKUP_BLADE_TYPE} required onChange={handleChangeBackupBladeType} style={{
                  width: 110,
                  }}>
                <MenuItem value={""}>Select</MenuItem>
                {backupBladeTypes && backupBladeTypes.map((backupbladetype, key) => (
                  <MenuItem value={backupbladetype}>{backupbladetype}</MenuItem>
                ))}
                </Select>
                </FormControl>
              </Col>
              )}
              {BACKUP_DEVICE  !== 'Other' && (
              <Col sm={2}>
                <FormControl>
                <InputLabel id="blade-size-label">Blade Size</InputLabel>
                <Select labelId="blade-size-label" value={BACKUP_BLADE_SIZE} required onChange={handleChangeBackupBladeSize} style={{
                  width: 100,
                  }}>
                <MenuItem value={""}>Select</MenuItem>
                {backupBladeSizes && backupBladeSizes.map((backupbladesize, key) => (
                  <MenuItem value={backupbladesize}>{backupbladesize}</MenuItem>
                ))}
                </Select>
                </FormControl>
              </Col>
              )}
              {BACKUP_DEVICE  === 'Other' && (
              <Col sm={4}>
                <TextField inputProps={{ style: { height: "10px", }, }} margin="normal" variant="outlined" fullWidth value={OTHER_BACKUP_DEVICE} onChange={e => setOtherBackupDevice(e.target.value)} required></TextField>
              </Col>
              )}
            </Row>
          )}
          <Row className="align-center">
            <Col xs={8} sm={8} md={4} lg={4}>Apneic Oxygenation</Col>
            <Col xs={4} sm={4} md={2} lg={2}>
            <CustomCheckbox checked={APNEIC_OXYGENATION === 'Y'} value="Y" onClick={handleApneic} inputProps={{ 'aria-label': 'controlled' }} required />
            </Col>
            <Col sm={6}>
            {APNEIC_OXYGENATION  === 'Y' && (
              <span className="small-note"><TextField inputProps={{ style: { height: "10px", }, }} className="rate-field" margin="normal" variant="outlined" size="small" label="Rate" required value={RATE} onChange={e => setRate(e.target.value)}></TextField> L/min  <img className="ao-default" src={AO_Default} alt="AO Default" /></span>  )}
            </Col>
          </Row>
          <p><span className="sub-header">Medication</span></p>
          <Row className="blue-row align-center">
            <Col xs={3} sm={4} md={4} lg={4}>Atropine</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Atropine" checked={medications.indexOf("Atropine") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
            <Col xs={3} sm={4} md={4} lg={4}>Midazolam</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Midazolam" checked={medications.indexOf("Midazolam") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
          </Row>
          <Row className="align-center">
            <Col xs={3} sm={4} md={4} lg={4}>Glycopyrrolate</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Glycopyrrolate" checked={medications.indexOf("Glycopyrrolate") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
            <Col xs={3} sm={4} md={4} lg={4}>Propofol</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Propofol" checked={medications.indexOf("Propofol") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
          </Row>
          <Row className="blue-row align-center">
            <Col xs={3} sm={4} md={4} lg={4}>Fentanyl</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Fentanyl" checked={medications.indexOf("Fentanyl") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
            <Col xs={3} sm={4} md={4} lg={4}>Rocoronium</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Rocoronium" checked={medications.indexOf("Rocoronium") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
          </Row>
          <Row className="align-center">
            <Col xs={3} sm={4} md={4} lg={4}>Ketamine</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Ketamine" checked={medications.indexOf("Ketamine") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
            <Col xs={3} sm={4} md={4} lg={4}>Vecuronium</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Vecuronium" checked={medications.indexOf("Vecuronium") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
          </Row>
          <Row className="blue-row align-center">
            <Col xs={3} sm={4} md={4} lg={4}>Other</Col>
            <Col xs={2} sm={2} md={2} lg={2}><CustomCheckbox value="Other" checked={medications.indexOf("Other") > -1} onClick={handleMedication} inputProps={{ 'aria-label': 'controlled' }} /></Col>
            <Col xs={6} sm={6} md={6} lg={6}>
            {medications.indexOf("Other") > -1 && (
              <Row className="adjust-row-width">
                <TextareaAutosize value={MEDICATION_OTHER_NOTES} onChange={e => setMedicationNotes(e.target.value)} placeholder="Please describe" />
              </Row>  
          )}
            </Col>
          </Row>
          <span><hr/></span>
          <Row className="align-center">
            <Col xs={8} sm={8} md={10} lg={8}><span className="sub-header">Airway Expert Request</span></Col>
            <Col xs={4} sm={4} md={2} lg={4}> &nbsp;&nbsp;Yes &nbsp;&nbsp;&nbsp; No</Col>
          </Row>
          <Row className="blue-row align-center">
            <Col xs={8} sm={8} md={10} lg={8}>Anesthesia</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  checked={ANESTHESIA === 'Y'}
                  onChange={handleAnesthesiaValue}
                  value="Y"
                  name="anesthesia-radio"
                  inputProps={{ 'aria-label': 'Y' }}
                  required
                />
                <Radio
                  checked={ANESTHESIA === 'N'}
                  onChange={handleAnesthesiaValue}
                  value="N"
                  name="anesthesia-radio"
                  inputProps={{ 'aria-label': 'N' }}
                  required
                />
            </Col>
          </Row>
          <Row className="align-center">
            <Col xs={8} sm={8} md={10} lg={8}>ENT</Col>
            <Col xs={4} sm={4} md={2} lg={4}>
                <Radio
                  checked={ENT === 'Y'}
                  onChange={handleENTValue}
                  value="Y"
                  name="ent-radio"
                  inputProps={{ 'aria-label': 'Y' }}
                  required
                />
                <Radio
                  checked={ENT === 'N'}
                  onChange={handleENTValue}
                  value="N"
                  name="ent-radio"
                  inputProps={{ 'aria-label': 'N' }}
                  required
                />
            </Col>
          </Row>
          <span><hr/></span>

          {decisions.toString()  !== '' && (
            <div>
              <span className="sub-header">Additional Consideration</span>
              <Container fluid="md" className="decision-support">
                <Row>
                  <Col xs={4} sm={4} md={4} lg={4}><span className="sub-header">Risk Factor</span></Col>
                  <Col xs={8} sm={8} md={8} lg={8}><span className="sub-header">Suggestion</span></Col>
                </Row>
              {decisions.includes('Shock') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>Shock/hemodynamic instability</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Prepare Fluid Bolus</li><li>Prepare Epinephrine bolus or infusion</li></ul></Col>
                </Row>
              )}
              {decisions.includes('Cardiac') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>Cardiac Arrest</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Is patient an ECMO candidate?</li><li>Is ECMO backup needed?</li></ul></Col>
                </Row>
              )}
              {decisions.includes('Respiratory') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>Respiratory Failure with high NIV/HFNC support</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Make LMA available at bedside</li></ul></Col>
                </Row>
              )}
              {decisions.includes('C-spine') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>C-spine precaution</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Prepare video laryngoscope</li></ul></Col>
                </Row>
              )}
              {decisions.includes('Overcirculation') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>Pulmonary Overcirculation</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Place bag on  oxygen blender</li></ul></Col>
                </Row>
              )}
              {decisions.includes('History') && (
                <Row className="row-small-spacing">
                <Col xs={4} sm={4} md={4} lg={4}>History or feature of difficult airway</Col>
                <Col xs={8} sm={8} md={8} lg={8}><ul><li>Review previously successful airway management</li><li>Prepare LMA and backup tool</li><li>Match provider skill with complexity</li></ul></Col>
                </Row>
              )}
              {decisions.includes('Obese') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>Obese patient</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Prepare ramp up system, oral airway</li><li>Start with two-person bag mask technique</li></ul></Col>
                </Row>
              )}
              {decisions.includes('Pulmonary') && (
                <Row className="row-small-spacing">
                  <Col xs={4} sm={4} md={4} lg={4}>Pulmonary edema/airway bleeding</Col>
                  <Col xs={8} sm={8} md={8} lg={8}><ul><li>Be ready to switch to direct laryngoscopy</li></ul></Col>
                </Row>
              )}
              </Container>
              <span><hr/></span>
            </div>
          )}

          <Row className="align-center custom-error">{helperErrorText}</Row>
          {isMobileOnly && (
            <div>
              <button className="submit-btn-close" id="close" onClick={e => planForm.current.buttonId=e.target.id}>Close</button>
              <button type="submit" className="submit-btn-save" id="saveclose" onClick={e => planForm.current.buttonId=e.target.id}>Save</button>
              <button type="submit" className="submit-btn-pink" id="save" onClick={e => planForm.current.buttonId=e.target.id}>Timeout</button>
            </div>
          )}
          {!isMobileOnly && (
            <div>
              <button className="submit-btn-close" id="close" onClick={e => planForm.current.buttonId=e.target.id}>Close without saving</button>
              <button type="submit" className="submit-btn-save" id="saveclose" onClick={e => planForm.current.buttonId=e.target.id}>Save & Close</button>
              <button type="submit" className="submit-btn-pink" id="save" onClick={e => planForm.current.buttonId=e.target.id}>Save & Start Timeout</button>
            </div>
          )}
        </Container>

      </form>
    </div>
  )
}

export default RiskAssessment;
